import type { PalantirLabelColors } from '../../shared/pipes/labels/labels.type';
import type { PalantirIcon } from '../icon/icon.type';

export interface PalantirSelectItemOverlayOptions<T> {
  cancelText: string;
  emptyText: string;
  height?: string;
  infiniteScroll?: {
    enabled: boolean;
    loadMore(skip: number, take: number, searchValue: string | null): Promise<T[]>;
    take?: number;
  };
  itemKey?: string;
  items: T[];
  limitItems?: number;
  map(item: T): PalantirSelectItemOverlayItem;
  search(value: string | null): Promise<T[]>;
  searchPlaceholderText: string;
  selectAllText: string;
  successText: string;
  type?: PalantirSelectItemOverlayType;
  width?: string;
}

export interface PalantirSelectItemOverlayItem {
  avatar?: {
    icon?: PalantirIcon;
    src?: string;
  };
  checked?: boolean;
  children?: PalantirSelectItemOverlayItem[];
  disabled?: boolean;
  id: number | string;
  tag?: PalantirSelectItemOverlayItemTag;
  title: string;
}

export interface PalantirSelectItemOverlayItemTag {
  color: PalantirLabelColors;
  label: string;
  prefix?: PalantirIcon;
  suffix?: PalantirIcon;
}

export enum PalantirSelectItemOverlayType {
  multiple = 'multiple',
  single = 'single',
}
